<template>
  <div>
    <company-search-box
      :info-text="i18n.t('/Company/CompanyZoekenModal/LokaalZoekenInfo')"
      @on-search="onSearch"
    />

    <loader v-if="isLoading" type="alert" />
    <alert v-if="errorText" :text="errorText" />
  </div>
</template>

<script>
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import CompanySearchBox from '@/components/generic/presentational/molecules/companySearch/CompanySearchBox.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Companies from '@/api/server/Companies'

export default {
  components: {
    Loader,
    CompanySearchBox,
    Alert,
  },
  emits: ['hasSearchedDealerCompanies'],
  data() {
    return {
      isLoading: false,
      userInput: '',
      errorText: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    async onSearch(query) {
      this.isLoading = true

      try {
        const companies = await Companies.searchCompany(query)
        this.$emit('hasSearchedDealerCompanies')
        StoreConnector.dispatch('companies/setSearchResults', companies)
      } catch (e) {
        this.errorText = this.i18n.t('/Company/CompanyZoekenModal/LokaalZoekenError')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style></style>
